import { render, staticRenderFns } from "./Sold.vue?vue&type=template&id=eb14dece&scoped=true&"
import script from "./Sold.vue?vue&type=script&lang=js&"
export * from "./Sold.vue?vue&type=script&lang=js&"
import style0 from "./Sold.vue?vue&type=style&index=0&id=eb14dece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb14dece",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
